import { writable } from 'svelte/store';
// -

export const langs = ['cat', 'esp', 'eng'];
export const lang = writable( langs[1] );

// -
export const phone = '608 505 777';

// -
export const showingLegal = writable(null);

// -
export const allowedCookies = writable(null);

// - 
export const overPhone = writable(null);

// -
export const totalLayers = 7;
export let scrollY = writable(0);

// - Resize
export const win = writable({
    width:      1024,
    height:     720,
    wMaxMd:     768,
    wMaxSm:     480
});

// - Preload
export let loaded = writable(null);